export function IconVector() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.05744 15.7951L1.83057 14.5733L7.87911 8.52971L11.0458 11.6964L15.2133 7.53971H12.8306V5.81055H18.1693V11.1443H16.4402V8.7618L11.0458 14.1403L7.87911 10.9737L3.05744 15.7951Z'
        fill='#5F6368'
      />
    </svg>
  );
}
